// *********************************************************************************************************************
// Custom JavaScript
// *********************************************************************************************************************


// =====================================================================================================================
// Breakpoint Manager
// =====================================================================================================================
import BreakpointManager from './breakpoint-manager'

// Custom Breakpoints object
const breakpoints = {
    xs:     0,
    sm:   576,
    md:   768,
    lg:  1100,
    xl:  1350,
    xxl: 1600,
}

// Instantiate the Breakpoint Manager
const breakpointManager = new BreakpointManager(breakpoints, true);



// =====================================================================================================================
// Nav Bar
// =====================================================================================================================

// Set up constants
const nav = document.getElementById("main-nav");
const adminBar = document.getElementById('wpadminbar'); // WordPress Admin Bar


// Change Nav state after scrolling down
// ---------------------------------------------------------------------------------------------------------------------
if (nav) {
    window.addEventListener('scroll', function () {
        const scrollPoint = 60; // pixel value after which state change is triggered
        if (this.scrollY > scrollPoint) {
            nav.classList.add('scrolled');
        } else if (this.scrollY <= 0 ) {
            nav.classList.remove('scrolled');
        }
    })
}



// Check for WordPress admin bar and pushes Nav down if it exists
// ---------------------------------------------------------------------------------------------------------------------
if (adminBar) {
    function setAdminBarHeight() {
        document.documentElement.style.setProperty('--admin-bar-height', adminBar.offsetHeight + "px");
    }

    window.addEventListener('load', setAdminBarHeight);
    document.addEventListener('DOMContentLoaded', setAdminBarHeight, false);
    window.addEventListener('resize', setAdminBarHeight, false);

    // Change Nav state after scrolling past start scrollPoint
    window.addEventListener('scroll', function () {
        if (breakpointManager.matchesBreakpointsDown('xs')) {
            let adminBarHeight = adminBar.offsetHeight;

            if (this.scrollY > adminBarHeight) {
                document.documentElement.style.setProperty('--admin-bar-height', "0px");
            } else if (this.scrollY < adminBarHeight) {
                let adminBarOffset = adminBarHeight  - this.scrollY;
                document.documentElement.style.setProperty('--admin-bar-height', adminBarOffset + "px");
            }
        }
    });

}